/**
 * 【【KYMW2300】印刷会社用データの作成要求VO
 *
 * @export ExecutePrintCompanyDataModel
 * @class ExecutePrintCompanyDataModel
 */
export class ExecutePrintCompanyDataModel {
  /** 受注コード */
  public orderCode = String('');
  /** 媒体区分 */
  public mediumType = String('');
  /** 生協コード */
  public coopCode = String('');
  /** 入稿データ */
  public manuscriptsData = String('');
  /** 校正リスト */
  public buyerDifferenceList = String('');
  /** 修正リスト */
  public editDifferenceList = String('');
  /** 出力対象フェーズ */
  public tarProgressNum = String('');
  /** 出力対象フェーズ名 */
  public tarProgressName = String('');
  /** 比較フェーズ */
  public comProgressNum = String('');
  /** 比較フェーズ名 */
  public comProgressName = String('');
  /** 出力方法タイプ */
  public outputType = String('');
  /** 出力方法 */
  public outputName = String('');
  /** 選択ページIDリスト　※、区切り */
  public pageIdList = String('');
  /** 選択ページ番号リスト　※、区切り */
  public pageNumList = String('');
}
